import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const lever = defineConnector({
  identifier: "lever",
  name: "Lever",
  tagLine: "Recruiting platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.lever\\.co/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.apiKey,
      password: "",
    }),
  steps: [
    {
      title: "Get your Lever API key",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to your Lever account and navigate to **Settings > Integrations and API > API Credentials** to generate an API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API Key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.lever.co/v1/users",
  },
});
